import * as React from "react";

import { UpdateControl, UFUpdateControl } from "../common/communication.base";
import { UFNclControlBase } from "../common/components.ncl";
import { WithContextPlacementProps, withContext, K2ComponentState, StyleHelper, AcquireControl } from "./k2hoc";
import { K2RuleWithVCXProps } from "./k2StyleRenderer";
import { K2TruncateText } from "./K2TruncateText";

const undefinedRule = (props: K2RuleWithVCXProps) => ({
  border: "1px solid " + props.vcx.getColor(props.vcx.Data.ColorMap.BaseColorBck1),
  color: props.vcx.getColor(props.vcx.Data.ColorMap.BaseColorBck1),
});

class _UndefinedControl extends React.PureComponent<WithContextPlacementProps, K2ComponentState<UFUpdateControl>> {
  static displayName = `K2UndefinedControl`;
  private control: UFNclControlBase;

  constructor(props: WithContextPlacementProps) {
    super(props);
    this.control = AcquireControl(this.props.controlUID, this.props.vrUID, (ctrl) => {
      return true;
    }) as UFNclControlBase;
    this.state = { data: this.control.init(this) as UFUpdateControl, vcxVersion: -1 };
  }

  updateState(state: UpdateControl) {
    this.setState((prevState: K2ComponentState<UFUpdateControl>) => {
      return { data: state as UFUpdateControl };
    });
  }

  updateVCX(vcxVersion: number) {
    this.setState({ vcxVersion: vcxVersion });
  }

  componentWillUnmount() {
    this.control.willUnMount(true);
    this.control = null;
  }

  render() {
    return (
      <div style={StyleHelper(this.control, this.props.style)} className={this.props.renderer.renderRule(undefinedRule, { vcx: this.control.VCX })}>
        <K2TruncateText>{"undefined control (" + this.control.MetaData.__type + ")"}</K2TruncateText>
      </div>
    );
  }
}

export const K2UndefinedControl = withContext(_UndefinedControl);
